import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_121: FaireProductEntity = {
  token: "legacy_prod_abbott-121",
  type: "product",
  name: "Beehive Honey Pot W Lid",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/92c7366e3dd16b565587160ed95aee667cea848c0fc41e510c15518faa589f81.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
